package team.platforma.materialextension.sample_screens

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.Button
import androidx.compose.material3.RangeSlider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import kotlinx.datetime.Clock
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format.FormatStringsInDatetimeFormats
import kotlinx.datetime.minus
import kotlinx.datetime.plus
import kotlinx.datetime.todayIn
import team.platforma.multiplatform_material_extension.calendar.calendar_period.api.CalendarPeriod
import team.platforma.multiplatform_material_extension.calendar.properties.CalendarViewProperties
import team.platforma.multiplatform_material_extension.calendar.calendar_regular.api.CalendarRegular
import team.platforma.multiplatform_material_extension.calendar.utils.CalendarRange
import team.platforma.multiplatform_material_extension.calendar.utils.rememberCalendarBadges
import team.platforma.multiplatform_material_extension.util.gestures.horizontalGestures
import team.platforma.multiplatform_material_extension.util.gestures.rememberHorizontalGestures
import kotlin.math.abs
import kotlin.math.roundToInt
import kotlin.random.Random

@OptIn(FormatStringsInDatetimeFormats::class)
@Composable
fun CalendarViewSample() {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {


        var selectedDate by remember { mutableStateOf<LocalDate?>(null) }
        var selectedMonth by remember { mutableStateOf<List<LocalDate>?>(null) }

        val calendarBadges = rememberCalendarBadges()
        val currentDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
        var calendarRange by remember {
            mutableStateOf(
                CalendarRange(
                    min = currentDate.plus(DatePeriod(years = 10)),
                    max = currentDate.minus(DatePeriod(years = 30))
                )
            )
        }

        val horizontalGestures1 = rememberHorizontalGestures()
        val horizontalGestures2 = rememberHorizontalGestures()
        var sliderPosition by remember { mutableStateOf(20f..60f) }
        Box(
            modifier = Modifier
                .widthIn(max = 600.dp)
                .fillMaxHeight()
        ) {
            LazyColumn(
                modifier = Modifier
            ) {
                item {
                    CalendarRegular(
                        modifier = Modifier.horizontalGestures(horizontalGestures1),
                        onDateSelected = {
                            selectedDate = it
                        },
                        onMonthSelected = {
                            println("CalendarLog onMonthSelected $it ")
                            val firstDate: LocalDate = it.first()

                            println("CalendarLog firstDate ${firstDate.monthNumber} ${firstDate.year} ")
                            selectedMonth = it
                        },
                        horizontalGestures = horizontalGestures1,
                        properties = CalendarViewProperties(
                            adaptiveHeight = true,
                            animateClickChangeButtonMonth = true,
                            animateBadge = true
                        ),
                        calendarBadges = calendarBadges,
                        calendarRange = calendarRange
                    )
                }
                item {
                    Column {
                        Text("Period Calendar")
                        CalendarPeriod(
                            modifier = Modifier.horizontalGestures(horizontalGestures2),
                            horizontalGestures = horizontalGestures2,
                            properties = CalendarViewProperties(
                                adaptiveHeight = true,
                                animateClickChangeButtonMonth = true,
                                animateBadge = true
                            ),
                            calendarBadges = calendarBadges,
                            calendarRange = calendarRange
                        )
                    }
                }
                item {
                    Row {
                        Button(
                            onClick = {
                                val mutableBadgesMap = mutableMapOf<String, Int>()
                                selectedMonth?.forEach { localDate ->
                                    mutableBadgesMap[localDate.toString()] = Random.nextInt(0, 200)
                                }
                                calendarBadges.setBadgeMap(mutableBadgesMap)
                            }
                        ) {
                            Text(
                                text = "Set badges"
                            )
                        }
                        Spacer(modifier = Modifier.width(4.dp))
                        Button(
                            onClick = {
                                val mutableBadgesMap = mutableMapOf<String, Int>()
                                selectedMonth?.forEach { localDate ->
                                    mutableBadgesMap[localDate.toString()] = 0
                                }
                                calendarBadges.setBadgeMap(mutableBadgesMap)
                            }
                        ) {
                            Text(
                                text = "Remove badges"
                            )
                        }
                        Spacer(modifier = Modifier.width(4.dp))

                    }
                }
                item {
                    Column {
                        RangeSlider(
                            value = sliderPosition,
                            steps = 99,
                            onValueChange = { range ->
                                sliderPosition = range

                                val newStart = range.start.coerceAtMost(50f)
                                val newEnd = range.endInclusive.coerceAtLeast(50f)

                                sliderPosition = newStart..newEnd

                                calendarRange = CalendarRange(
                                    min = currentDate.plus(DatePeriod(years = abs(sliderPosition.endInclusive - 50f).roundToInt())),
                                    max = currentDate.minus(DatePeriod(years = abs(sliderPosition.start - 50f).roundToInt()))
                                )

                            },
                            valueRange = 0f..100f,
                            onValueChangeFinished = {},
                        )
                        Text(text = "Период календаря: от[${calendarRange.max}] до[${calendarRange.min}]")
                        Text(text = "Выбранная дата: $selectedDate")
                    }
                }

            }

        }


    }
}